window.dataLayer = window.dataLayer || []

export const pushLoggedStateToDatalayer = () => {
  dataLayer.push({ user_state: 'logged' }) // eslint-disable-line no-undef
}
